import { getUserPersistedFlight } from '../services/getUserPersistedFlight';
import { GetUserPersistedFlightResponse } from '../services/GetUserPersistedFlightResponse';
import premiumFlightStore from '../store/premiumFlightStore';
import persistResponse from '../mutators/persistResponse';

export async function isFlightPersisted(flightName: string) {
    if (!premiumFlightStore.isInit) {
        let response: GetUserPersistedFlightResponse = await getUserPersistedFlight();
        persistResponse(response);
    }

    for (let flight of premiumFlightStore.flightNames) {
        if (flight === flightName.toLowerCase()) {
            return true;
        }
    }

    return false;
}
